<template>
  <a v-if="!data.form_data">{{ linkText }}</a>
  <a v-else-if="assignmentId !== 0" :href="`/admin/participant/edit/${elementId}/history/${assignmentId}?${historyEditQueryParams}`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.ACTIVITIES_SERVICES" :href="`/admin/activities-and-services/user/${elementId}/edit/${formDataId}?${isOpenQueryParam}`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.ASSESSMENT_OUTCOMES" :href="`/admin/assessment-and-outcomes/user/${elementId}/edit/${formDataId}?${isOpenQueryParam}`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.PARTICIPANT_PROFILE" :href="`/admin/participant/edit/${elementId}`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.PARTICIPANT_ASSIGNMENT" :href="`/admin/participant/edit/${elementId}/assignment`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.PARTICIPANT_CONTACT" :href="`/admin/participant/edit/${elementId}/contact`">{{ linkText }}</a>
  <a v-else-if="moduleId === moduleType.ORGANIZATION_GENERAL" :href="`/admin/general-forms/edit/${formDataId}?${isOpenQueryParam}`">{{ linkText }}</a>
  <span v-else>{{ linkText }}</span>
</template>

<script>
import {ModuleType} from "../../enums/moduleType";
import {QueryParam} from "../../enums/queryParam";

export default {
  name: "FormEditLink",
  props: {
    data: {
      type: Object,
      default: {
        form_data: null
      },
      required: false
    }
  },
  computed: {
    historyEditQueryParams(){
      const data = {
        [QueryParam.MODULE_ID]: this.moduleId,
        [QueryParam.FORM_DATA_ID]: this.formDataId,
        [QueryParam.ACTIVE_TAB]: 'modifyForms',
        [QueryParam.IS_OPEN]: 'true'
      }
      const searchParams = new URLSearchParams(data);

      return searchParams.toString();
    },
    isOpenQueryParam(){
      const data = {
        [QueryParam.IS_OPEN]: 'true'
      }
      const searchParams = new URLSearchParams(data);

      return searchParams.toString();
    },
    moduleType() {
      return ModuleType
    },
    elementId(){
      return this.data.form_data.element_id
    },
    formDataId(){
      return this.data.form_data.form_data_id
    },
    moduleId(){
      return parseInt(this.data.form_data.module_id ? this.data.form_data.module_id : this.moduleType.ACTIVITIES_SERVICES)
    },
    assignmentId(){
      if (!this.data.form_data.assignment_id){
        return 0
      }

      return parseInt(this.data.form_data.assignment_id)
    },
    linkText() {
      if (!this.data.td){
        return ''
      }

      return this.data.td.replaceAll('|', ' ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormEditLink.vue?2df82cbc